import { render, staticRenderFns } from "./tutorial.vue?vue&type=template&id=5b5adb40&"
import script from "./tutorial.vue?vue&type=script&lang=ts&"
export * from "./tutorial.vue?vue&type=script&lang=ts&"
import style0 from "./tutorial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports